import { For, Show } from 'solid-js';
import type { ProjectManifest } from '../../types/project';
import { projectDisplayTitle } from '../../types/project';
import { PixelIcon } from '../PixelIcon';
import { ProjectIcon } from '../ProjectIcon';

interface RecycleBinWindowProps {
  projects: ProjectManifest[];
  openProject: (project: ProjectManifest) => void;
}

export function RecycleBinWindow(props: RecycleBinWindowProps) {
  const archived = () => props.projects.filter((project) => project.status === 'archived');

  return (
    <div class="window-body app-window-body recycle-window">
      <div class="recycle-heading">
        <PixelIcon name="recycle" size={52} />
        <div>
          <h1>Recycle Bin</h1>
          <p>Retired, superseded, or deliberately unfinished experiments.</p>
        </div>
      </div>

      <div class="sunken-panel recycle-list">
        <Show
          when={archived().length > 0}
          fallback={
            <div class="empty-recycle-bin">
              <PixelIcon name="recycle" size={44} />
              <strong>The Recycle Bin is empty.</strong>
              <span>Archived projects will appear here automatically.</span>
            </div>
          }
        >
          <For each={archived()}>
            {(project) => (
              <button class="recycle-item" onDblClick={() => props.openProject(project)}>
                <ProjectIcon project={project} size={28} />
                <span>
                  <strong>{projectDisplayTitle(project)}</strong>
                  <small>{project.summary}</small>
                </span>
              </button>
            )}
          </For>
        </Show>
      </div>
      <p class="dialog-note">Nothing here is deleted from storage. An archived project remains linkable and runnable; it simply leaves the main project list.</p>
    </div>
  );
}
